export function videoPopup() {
    $('.sb-video-modal').on('show.bs.modal', function (event) {
        $('.sb-video-iframe', this).attr('src', $('.sb-video-iframe', this).data('src'));
    });
}